/**
 * OTP Agrár Nyeremény játék összegző oldal
 *
 * @author Erik Bánhalmi @2017.01.12.
 */
import template from './nyeremenyjatek-osszegzo.pug';
const MODULE_NAME = 'nyeremenyjatekOsszegzo';
class NyeremenyjatekOsszegzoController {
	constructor() {
		'ngInject';
	}
}

export default angular.module(MODULE_NAME, [])
	.component('nyeremenyjatekOsszegzo', {
		controller: NyeremenyjatekOsszegzoController,
		template: template()
	}).name;




// WEBPACK FOOTER //
// ./source/applications/nyeremenyjatek-osszegzo/nyeremenyjatek-osszegzo.js